import React from "react";
import Ajax from "../../../Ajax";
import { useState } from "react"
import { observer } from "mobx-react-lite";
import { store } from "../../../stores/Store";
import { Button } from "@mui/material"
import AbsenceTable from "./AbsenceTable";
import IllegalPresenceTable from "./IllegalPresenceTable";
import { Icons } from "../../../misc/Icons";
import { UTCDate } from "@date-fns/utc";


export default observer(function AbsenceForm () {

    const { instruction, queryPeriodStartDate, queryPeriodEndDate } = store.QuestionStore.informationRequest
    const field: any = store.QuestionStore.informationRequest.requestedFieldsObj[0]

    const absenceBlock = JSON.parse(field.enteredValuesObj[0])
    
    const [submitting, setSubmitting] = React.useState(false)
    const [warnings, setWarnings] = useState<string[]>([])
    
    const [absenceRows, setAbsenceRows] = useState(absenceBlock.AbsenceItems ? absenceBlock.AbsenceItems : [])
    const [illegalPresenceRows, setIllegalPresenceRows] = useState(absenceBlock.IllegalPresenceItems ? absenceBlock.IllegalPresenceItems : [])

    // Convert date strings to Date obejcts
    const periodStart = new UTCDate(field.queryPeriodStartDate);
    const periodEnd = field.queryPeriodEndDate?.includes("9999") ? new UTCDate() : new UTCDate(field.queryPeriodEndDate);

    absenceBlock.AbsenceItems.forEach(row => {
        row.ToDate = new UTCDate(row.ToDate)
        row.FromDate = new UTCDate(row.FromDate)
    })
    absenceBlock.IllegalPresenceItems.forEach(row => {
        row.ToDate = new UTCDate(row.ToDate)
        row.FromDate = new UTCDate(row.FromDate)
    })

    const attemptSubmit = async () => {

        setSubmitting(true)
        var allWarnings = validate()

        var newAbsenceBlock = {
            Uid: absenceBlock.Uid,
            AbsenceItems: absenceRows,
            IllegalPresenceItems: illegalPresenceRows,
        }

        if (allWarnings.length === 0) {

            await Ajax.Message.RespondAbsence(newAbsenceBlock).then(() => {

                store.QuestionStore.informationRequest = null
                store.AlertStore.Close()

                if (store.AppStore.stateAction === "Editing") {
                    store.NodeStore.refreshLeafNode()
                }

            }).catch((response) => setWarnings([response.data?.detail]))

        }

        setSubmitting(false)
    }


    const reorderRows = (rows: any[]) => {
        return [...rows].sort((a: any, b: any) => {
            return new UTCDate(a.FromDate) > new UTCDate(b.FromDate) ? 1 : -1
        })
    }

    const validateDates = (rows, tableName) => {

        var newWarnings = []

        rows.forEach((row, r) => {

            var rowTo = row.ToDate
            var rowFrom = row.FromDate
            console.log(tableName, row, rowTo, rowFrom)

            // Check if start date is after end date
            if (rowFrom > rowTo) {
                newWarnings.push(`${tableName} row ${r+1}: There must be at least one day between the "To date" and the "From date"`)
            }

            // Check for dates outside the date range
            if (rowFrom < periodStart || rowTo > periodEnd) {
                newWarnings.push(`${tableName} row ${r+1} is outside the time period`)
            }

            // Check for overlapping rows on absence table
            absenceRows.forEach((cRow, cr) => {
                if (row === cRow) { return }

                var cRowTo = cRow.ToDate
                var cRowFrom = cRow.FromDate

                if ((rowTo > cRowFrom && rowTo < cRowTo) || (rowFrom > cRowFrom && rowFrom < cRowTo)) {
                    newWarnings.push(`${tableName} row ${r+1} overlaps absence row ${cr+1}`)
                }
            })

            // Check for overlapping rows on absence table
            illegalPresenceRows.forEach((cRow, cr) => {
                if (row === cRow) { return }

                var cRowTo = cRow.ToDate
                var cRowFrom = cRow.FromDate

                if ((rowTo > cRowFrom && rowTo < cRowTo) || (rowFrom > cRowFrom && rowFrom < cRowTo)) {
                    newWarnings.push(`${tableName} row ${r+1} overlaps presence row ${cr+1}`)
                }
            })
        })

        return newWarnings
    }

    const validate = () => {

        setWarnings([])
        var completenessWarnings = []

        // Reorder rows
        setAbsenceRows(reorderRows(absenceRows))
        setIllegalPresenceRows(reorderRows(illegalPresenceRows))

        // Check for incompleteness
        var incompleteAbsenceRows = absenceRows.filter((row, r) => (!row.FromDate || !row.ToDate || !row.CountriesVisited.length || !row.Purpose))
        var incompletePresenceRows = illegalPresenceRows.filter((row, r) => (!row.FromDate || !row.ToDate))

        !!incompleteAbsenceRows.length && completenessWarnings.push("Absence rows are incomplete")
        !!incompletePresenceRows.length && completenessWarnings.push("Illegal presence rows are incomplete")

        var absenceValidation = validateDates(absenceRows, "absence")
        var presenceValidation = validateDates(illegalPresenceRows, "presence")

        console.log("Warnings", completenessWarnings, absenceValidation, presenceValidation)

        var allWarnings = [...completenessWarnings, ...absenceValidation, ...presenceValidation]
        setWarnings(allWarnings)
        return allWarnings
    }

    return (
        <div className="form form-absence">

            <h2>Absence from the United Kingdom</h2>

            <div style={{maxHeight: "60vh", overflowY: "auto"}}>
                <p>{instruction[0]}</p>

                <AbsenceTable 
                    periodStart={queryPeriodStartDate} 
                    periodEnd={queryPeriodEndDate} 
                    rows={absenceRows} 
                    onChange={(rows) => setAbsenceRows(rows)} />

                <br/>

                <h3>Illegal presence in the United Kingdom</h3>

                <p>{instruction[1]}</p>
                <p style={{margin: 0}}><i>Note: Please record any partial days where the person was illegally present</i></p>

                <IllegalPresenceTable 
                    periodStart={queryPeriodStartDate} 
                    periodEnd={queryPeriodEndDate} 
                    rows={illegalPresenceRows} 
                    onChange={(rows) => setIllegalPresenceRows(rows)} />
            </div>

            {warnings?.length ? (
                <div className="warning">
                    {warnings.map((warning, i) => <span><Icons.Dot style={{fontSize: "8px", marginLeft: "10px"}} /> {warning}</span>)}
                </div>
            ) : null}

            <div style={{display: "flex", justifyContent: "space-between"}}>        
                {/* <Button variant="contained" className="btn btn-sm" onClick={() => validate()}>Validate</Button> */}
                <Button 
                    color="success"
                    variant="contained" 
                    className="btn btn-md" 
                    disabled={submitting}
                    onClick={() => attemptSubmit()}>
                    Save and close
                </Button>
            </div>
        </div>
    )
})